import React from 'react';
import PropTypes from 'prop-types';

const TargetPosition = ({value, onChange = () => {}}) => (
    <div className="personal-info__item">
        <div className="personal-info__lbl">Target position</div>
        <div className="personal-info__value">
            <input value={value}
                   onChange={(event) => {onChange(event.target.value)}}
                   id="target"
                   className="target-position__input"
                   name="target"
                   type="text"
                   placeholder="For example, Project Manager, IT Developer etc." />
        </div>
    </div>
)

TargetPosition.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
};

export default TargetPosition
